import React, { useState } from "react";
import { Box, Typography, Button, Alert, Modal } from "@bca/ui-library";

import TermsAndConditions from "./TermsAndConditions";
import Spinner from "../Spinner";
import { formatMoney } from "./formatMoney";

interface ConfirmProxyBidModalProps {
  onClose: () => void;
  onConfirm: () => void;
  bidAmount: number;
  isOpen: boolean;
  termsAndConditionsNeedAccepting: boolean;
  termsAndConditionsLink: string;
  isLoading: boolean;
}

const ConfirmProxyBidModal: React.FunctionComponent<ConfirmProxyBidModalProps> = ({
  onClose,
  onConfirm,
  bidAmount,
  isOpen,
  termsAndConditionsNeedAccepting,
  termsAndConditionsLink,
  isLoading,
}) => {
  const [checked, setChecked] = useState(false);

  return (
    <Modal role="dialog" onClose={onClose} isOpen={isOpen}>
      <Box display="flex" justifyContent="space-between" mb={24}>
        <Box display="flex" flexDirection="column">
          <Typography variant="h6" m={0} color="footer-blue">
            Confirm your Proxy Bid
          </Typography>
          <Typography
            css={`
              font-size: 30px;
              font-weight: 500;
            `}
            m={0}
            color="#0b0b0b"
          >
            {formatMoney(bidAmount)}
          </Typography>
        </Box>
      </Box>
      <Alert
        paddingX={30}
        paddingY={24}
        title="By pressing Confirm, you commit to buy this vehicle if you are the
        winning bidder."
      ></Alert>
      {termsAndConditionsNeedAccepting && (
        <TermsAndConditions
          checked={checked}
          setChecked={setChecked}
          termsAndConditionsLink={termsAndConditionsLink}
        />
      )}
      <Box display="flex" justifyContent="space-between" mt={24}>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="primary-gradient"
          onClick={onConfirm}
          disabled={isLoading || (termsAndConditionsNeedAccepting && !checked)}
          minWidth={120}
          data-en="click"
          data-ec="button"
          data-el="proxyBid"
          data-ea="confirmation"
          data-ev={bidAmount}
          data-es=""
        >
          {isLoading ? <Spinner /> : "Confirm"}
        </Button>
      </Box>
    </Modal>
  );
};

export default ConfirmProxyBidModal;
